import { ApplicationState } from "../ApplicationState";

export const reviewsSelector = (state: ApplicationState) => {
    return state.reviews.reviews;
}

export const reviewCountSelector = (state: ApplicationState) => {
    return state.reviews.reviewCount;
}
